import { useMutation, UseMutationOptions, UseMutationResult } from '@tanstack/react-query';

import AmplifyApiService from '../../services/AmplifyApiService';
import IAmplifyApiConfig from '../../shared/interfaces/IAmplifyApiConfig';
import { ILocation, MainRoute } from '../../shared/interfaces/IFootprint';

const amplifyApiService = new AmplifyApiService();

const BASE_PATH = 'transport-emissions';

export enum WeightUnit {
  KILOGRAMS = 'KILOGRAMS',
}

export type CalculateTransportEmissionRequest = {
  weight: number;
  unit: WeightUnit;
  transportMode: MainRoute;
  startLocation: ILocation['coordinates'];
  endLocation: ILocation['coordinates'];
};

export type CalculateTransportEmissionResponse = {
  distance: number;
  totalEmissions: number;
};

export const useCalculateTransportEmissions = (
  options: UseMutationOptions<
    CalculateTransportEmissionResponse,
    Error,
    CalculateTransportEmissionRequest
  > = {},
): UseMutationResult<
  CalculateTransportEmissionResponse,
  Error,
  CalculateTransportEmissionRequest
> => {
  const mutation = useMutation<
    CalculateTransportEmissionResponse,
    Error,
    CalculateTransportEmissionRequest
  >({
    mutationFn: async (body: CalculateTransportEmissionRequest) => {
      const amplifyApiConfig: IAmplifyApiConfig = {
        apiName: 'PacificApi',
        path: `${BASE_PATH}/calculate`,
        options: { body },
      };

      return await amplifyApiService.post<
        CalculateTransportEmissionRequest,
        CalculateTransportEmissionResponse
      >(amplifyApiConfig);
    },
    ...options,
  });

  return mutation;
};
